<template>
  <div class="card my-3 px-3 py-3">
    <h5 style="color: #000; text-align: center">{{ title }}</h5>
    <apexchart
      type="bar"
      :height="chart_height"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
export default {
  props: [
    'title', 
    'values', 
    'categories',
    'plot_options',
    'fill',
    'data_labels',
    'legend',
    'yaxis',
    'tooltip',
    'chart_height',
  ],
  data: function() {
    return {
      chartOptions: {
        chart: {
          id: "barchart",
            toolbar: {
              show: false,
            },
            type: 'bar',
            stacked: true,
            stackType: '100%'
        },
        colors: ['#f26143', '#ffa07a', '#f3e89e', '#90ee90', '#27ae60'],
        plotOptions: this.plot_options ?? {
          bar: {
            horizontal: true,
            barHeight: 50,
            columnsWidth: 50,
          },
        },
        theme: {
          palette: "palette7",
        },
        fill: this.fill ?? {
          colors: ['#f26143', '#ffa07a', '#f3e89e', '#90ee90', '#27ae60']
        },
        dataLabels: this.data_labels ?? {
          style: {
          colors: ['#8b0000', '#8b0000', '#b8860b', '#006400', '#006400']
          }
        },
        legend: this.legend ?? {},
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: this.categories,
          labels: {
            show: false
          }
        },
        tooltip: this.tooltip ?? {
          theme: 'dark',
        },
        yaxis: this.yaxis ?? {
          show: true,
          labels: {
            fontWeight: '600'
          }
        },
      },

      series: this.values
    };
  }
};
</script>